var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11H11.5V13C11.5 13.2652 11.3946 13.5196 11.2071 13.7071C11.0196 13.8946 10.7652 14 10.5 14C10.2348 14 9.98043 13.8946 9.79289 13.7071C9.60536 13.5196 9.5 13.2652 9.5 13V11H7.5C7.23478 11 6.98043 10.8946 6.79289 10.7071C6.60536 10.5196 6.5 10.2652 6.5 10C6.5 9.73478 6.60536 9.48043 6.79289 9.29289C6.98043 9.10536 7.23478 9 7.5 9H9.5V7C9.5 6.73478 9.60536 6.48043 9.79289 6.29289C9.98043 6.10536 10.2348 6 10.5 6C10.7652 6 11.0196 6.10536 11.2071 6.29289C11.3946 6.48043 11.5 6.73478 11.5 7V9H13.5C13.7652 9 14.0196 9.10536 14.2071 9.29289C14.3946 9.48043 14.5 9.73478 14.5 10C14.5 10.2652 14.3946 10.5196 14.2071 10.7071C14.0196 10.8946 13.7652 11 13.5 11ZM1.5 0H19.5C19.7652 0 20.0196 0.105357 20.2071 0.292893C20.3946 0.48043 20.5 0.734784 20.5 1V19C20.5 19.2652 20.3946 19.5196 20.2071 19.7071C20.0196 19.8946 19.7652 20 19.5 20H1.5C1.23478 20 0.980429 19.8946 0.792892 19.7071C0.605356 19.5196 0.5 19.2652 0.5 19V1C0.5 0.734784 0.605356 0.48043 0.792892 0.292893C0.980429 0.105357 1.23478 0 1.5 0ZM2.5 18H18.5V2H2.5V18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBorder);
export default __webpack_public_path__ + "static/media/PlusIconBorder.44b6781f8504f600af25253db48ba182.svg";
export { ForwardRef as ReactComponent };